import ApiService from './ApiService'

export async function apiSendChatMessage(data) {
    return ApiService.fetchData({
        url: '/chat/message',
        method: 'post',
        data,
    })
}

export async function apiListChats() {
    return ApiService.fetchData({
        url: '/chat',
        method: 'get',
    })
}

export async function apiGetChatHistory(data) {
    return ApiService.fetchData({
        url: '/chat/history',
        method: 'post',
        data,
    })
}

export async function apiUpdateChatSession(data) {
    return ApiService.fetchData({
        url: '/chat/session/update',
        method: 'post',
        data,
    })
}

export async function apiUploadChatAttachment(data) {
    return ApiService.fetchData({
        url: '/chat/attachments/upload',
        method: 'post',
        data,
    })
}

export async function apiGenerateKBMockup(data) {
    return ApiService.fetchData({
        url: '/chat/kb-mockup',
        method: 'post',
        data,
    })
}

export async function apiResolveChatAction(data) {
    return ApiService.fetchData({
        url: '/chat/actions/resolve',
        method: 'post',
        data,
    })
}